import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=7dfced84&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/components/feedbacks/loading.scss?vue&type=style&index=0&id=7dfced84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfced84",
  null
  
)

export default component.exports